import axios from "axios";

export default {
  namespaced: true,
  state: {
    notifications: [],
    options: {
      assigneeOptions: [],
      disclosureOptions: [],
      contentStatusOptions: [
        { value: "OPEN", text: "Open", disabled: false, update: false },
        {
          value: "ACTIVE",
          text: "\u00A0\u00A0\u00A0\u00A0\u00A0Active",
          disabled: false,
          update: false,
        },
        {
          value: "TO_DO",
          text: "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0To Do",
          disabled: false,
          update: true,
        },
        {
          value: "IN_PROGRESS",
          text: "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0In Progress",
          disabled: false,
          update: true,
        },
        {
          value: "DONE",
          text: "\u00A0\u00A0\u00A0\u00A0\u00A0Done",
          disabled: false,
          update: true,
        },
        {
          value: "CANCELLED",
          text: "\u00A0\u00A0\u00A0\u00A0\u00A0Cancelled",
          disabled: false,
          update: true,
        },
        { value: "CLOSED", text: "Closed", disabled: false, update: true },
      ],
      disclosureStatusOptions: [
        { value: "", text: "" },
        { value: "OPEN", text: "Open", disabled: false, update: false },
        { value: "CLOSED", text: "Closed", disabled: false, update: true },
      ],
    }
  },
  getters: {
    filter(state) {
      return state.filter;
    },
    options(state) {
      return state.options;
    },
    disclosureOptions(state) {
      return state.options.disclosureOptions;
    },
    statusOptions(state) {
      return state.options.contentStatusOptions;
    },
    users(state) {
      return state.options.assigneeOptions;
    },
    disclosureStatusOptions(state) {
      return state.options.disclosureStatusOptions;
    },
    notifications(state) {
      return state.notifications;
    }
  },
  actions: {
    async retrieveDisclosureOptions({ state, commit }) {
      if (state.options.disclosureOptions.length > 0) return;
      const response = await axios.get('esg/disclosure/disclosures', {
        headers: { Authorization: accessToken() }
      });
      commit('setDisclosureOptions', response.data.list);
    },
    async retrieveUsers({ state, commit }) {
      if (state.options.assigneeOptions.length > 0) return;
      const response = await axios.get('esg/disclosure/users', {
        headers: { Authorization: accessToken() }
      });
      commit("setUsers", response.data.list);
    },
    async retrieveNotifications({ commit }) {
      const response = await axios.get('esg/disclosure/notifications', {
        headers: { Authorization: accessToken() }
      });
      commit('initializeNotifications', response.data.list);
    }
  },
  mutations: {
    setDisclosureOptions(state, disclosures) {
      state.options.disclosureOptions = disclosures;
    },
    setUsers(state, users) {
      users.forEach(user => {
        user.value = user.userId;
        user.text = user.userName;
      });
      users.sort((a, b) => a.text.localeCompare(b.text));
      state.options.assigneeOptions = users;
    },
    initializeNotifications(state, notifications) {
      state.notifications = notifications;
    },
    setNotifications(state, notification) {
      state.notifications = [notification, ...state.notifications]
    }
  },
};